import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import { SubmitButton } from 'Elements/Form';

import UserActiveStatus from './UserActiveStatus';
import UserBasicInfo from './UserBasicInfo';

const Height100 = styled.div`
  height: 100%;
`;

const ScrollOverflow = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
`;

type Props = {
  title: string;
  subtitle?: string;
};

export default function UserPage({ title, subtitle }: Props) {
  return (
    <Grid container direction="column" component={Height100}>
      <AppBar>
        <Toolbar>
          <div>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
          </div>
          <SubmitButton color="secondary" variant="contained">
            Tallenna
          </SubmitButton>
        </Toolbar>
      </AppBar>
      <Grid component={ScrollOverflow} item xs>
        <Grid container spacing={3}>
          <Grid item sm={12} md={7} lg={7} xl={8}>
            <UserBasicInfo />
          </Grid>
          <Grid item sm={12} md={5} lg={5} xl={4}>
            <UserActiveStatus />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
